<template>
  <div v-if="id">
    <!-- Modal Modernizado -->
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      :id="
        modal_id != ''
          ? `modalDataCertificate${modal_id}${id}`
          : `modalDataCertificate${id}`
      "
      centered
      modal-class="modern-certificate-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-certificate mr-2"></i>
          Documentos com Certificado Digital
        </div>
      </template>

      <div class="certificate-modal-content">
        <!-- Header com informações importantes -->
        <div class="certificate-header">
          <div class="certificate-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <div class="certificate-header-content">
            <h3 class="certificate-title">Documentos Digitalmente Assinados</h3>
            <p class="certificate-subtitle">
              Documentos protegidos por certificado digital ICP-Brasil
            </p>
          </div>
        </div>

        <!-- Information Section -->
        <div class="certificate-info-section">
          <div class="info-card">
            <div class="info-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <div class="info-content">
              <h5 class="info-title">Como verificar a autenticidade?</h5>
              <p class="info-text">
                Para verificar a autenticidade deste documento, faça o download
                e utilize o verificador oficial do ITI (Instituto Nacional de
                Tecnologia da Informação).
              </p>
            </div>
          </div>

          <!-- ITI Link -->
          <div class="iti-verification">
            <h5 class="verification-title">
              <i class="fas fa-search mr-2"></i>
              Verificação de Autenticidade
            </h5>
            <a
              href="https://validar.iti.gov.br/"
              target="_blank"
              rel="noopener noreferrer"
              class="iti-link"
            >
              <div class="iti-link-content">
                <div class="iti-logo">
                  <i class="fas fa-external-link-alt"></i>
                </div>
                <div class="iti-details">
                  <span class="iti-name">Verificador ITI</span>
                  <span class="iti-description">
                    Instituto Nacional de Tecnologia da Informação
                  </span>
                  <span class="iti-url">validar.iti.gov.br</span>
                </div>
                <div class="iti-arrow">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- Loading State -->
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <!-- Certificates Section -->
          <div class="certificates-section">
            <div class="section-header">
              <h4 class="section-title">
                <i class="fas fa-file-signature mr-2"></i>
                Documentos Disponíveis
                <span class="certificates-count"
                  >({{ certificates_data_base64.length }})</span
                >
              </h4>
            </div>

            <!-- No Certificates State -->
            <div
              v-show="certificates_data_base64.length == 0"
              class="no-certificates"
            >
              <i class="fas fa-file-excel no-certificates-icon"></i>
              <h5 class="no-certificates-title">Nenhum documento encontrado</h5>
              <p class="no-certificates-text">
                Não há documentos com certificado digital disponíveis no
                momento.
              </p>
            </div>

            <!-- Certificates Grid -->
            <div
              v-if="certificates_data_base64.length > 0"
              class="certificates-grid"
            >
              <div
                v-for="(item, key) in certificates_data_base64"
                :key="key"
                class="certificate-card"
              >
                <!-- Card Header -->
                <div class="card-header-cert">
                  <div class="card-icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                  <div class="card-badge">
                    <i class="fas fa-certificate mr-1"></i>
                    Assinado
                  </div>
                </div>

                <!-- Card Content -->
                <div class="card-content-cert">
                  <!-- Resident Info -->
                  <div class="cert-info-item">
                    <div class="cert-label">
                      <i class="fas fa-user mr-1"></i>
                      Residente
                    </div>
                    <div class="cert-value">
                      {{ item.resident_name || "Não informado" }}
                    </div>
                  </div>

                  <!-- Signer Info -->
                  <div class="cert-info-item">
                    <div class="cert-label">
                      <i class="fas fa-user-md mr-1"></i>
                      Assinado por
                    </div>
                    <div class="cert-value">
                      {{ item.user_name || "Não informado" }}
                    </div>
                  </div>

                  <!-- Date Info -->
                  <div class="cert-info-item">
                    <div class="cert-label">
                      <i class="fas fa-clock mr-1"></i>
                      Data/Hora
                    </div>
                    <div class="cert-value">
                      {{ moment(item.created_at).format("DD/MM/YYYY") }}
                      <span class="cert-time">
                        às {{ moment(item.created_at).format("HH:mm:ss") }}
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Card Actions -->
                <div class="card-actions-cert">
                  <v-btn
                    class="btn-download-cert"
                    @click="linkPDF(item.data_base64)"
                    block
                  >
                    <i class="fas fa-link mr-2"></i>
                    Acessar PDF Assinado
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>

        <!-- Footer Information -->
        <div class="certificate-footer">
          <div class="security-info">
            <i class="fas fa-lock mr-2"></i>
            <span
              >Documentos protegidos por certificado digital ICP-Brasil</span
            >
          </div>
          <div class="validation-info">
            <i class="fas fa-check mr-2"></i>
            <span>Validação disponível 24h através do ITI</span>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Botão Principal Modernizado -->
    <v-btn
      :x-small="x_small"
      :class="[
        'btn-certificate-modern',
        small ? 'btn-certificate-small' : 'btn-certificate-large',
      ]"
      @click="openModalDataCertificate()"
    >
      <i class="fas fa-signature mr-2"></i>
      <span :class="['btn-text', x_small && 'btn-text-x-small']">
        {{ text_button ? text_button : "ASSINATURAS COM CERTIFICADO DIGITAL" }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import api from "../../services/api";

import moment from "moment";

export default {
  name: "ButtonGenerateCertificate",

  props: {
    id: { type: [String, Number], default: "" },
    modal_id: { type: [String, Number], default: "" },
    small: { type: Boolean, default: false },
    data_base64: { type: String, default: "" },
    x_small: { type: Boolean, default: false },
    text_button: { type: String, default: "" },
  },

  data() {
    return {
      loading: false,
      certificates_data_base64: [],
    };
  },

  methods: {
    moment,

    openModalDataCertificate() {
      let { modal_id } = this;
      if (modal_id != "") {
        this.$bvModal.show(`modalDataCertificate${modal_id}${this.id}`);
      } else {
        this.$bvModal.show(`modalDataCertificate${this.id}`);
      }

      this.getCertificatesDataBase64();
    },

    async getCertificatesDataBase64() {
      try {
        this.loading = true;

        const { id } = this;

        let params = {
          id,
        };

        const response = await api.get("/rest-home/certificate/data/base64", {
          params,
        });

        const { certificates_data_base64 } = response.data;

        this.certificates_data_base64 = certificates_data_base64;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },

    async linkPDF(url) {
      window.open(url, "_blank");
    },

    downloadPDF(data_base64) {
      try {
        const cleanBase64 = data_base64.replace(
          /^data:application\/pdf;base64,/,
          ""
        );

        const byteCharacters = atob(cleanBase64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `documento_certificado_${moment().format(
          "DDMMYYYY_HHmmss"
        )}.pdf`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log("Erro ao fazer download:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Botão Principal */
.btn-certificate-modern {
  background: linear-gradient(135deg, #16a34a 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(22, 163, 74, 0.3) !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  overflow: hidden !important;
}

.btn-certificate-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(22, 163, 74, 0.4) !important;
}

.btn-certificate-modern:active {
  transform: translateY(0) !important;
}

.btn-certificate-large {
  padding: 12px 24px !important;
  font-size: 14px !important;
}

.btn-certificate-small {
  padding: 8px 16px !important;
  font-size: 12px !important;
}

.btn-certificate-modern .btn-text {
  position: relative;
  z-index: 2;
}

.btn-certificate-modern .btn-text-x-small {
  font-size: 10px;
}

.btn-certificate-modern::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.btn-certificate-modern:hover::before {
  left: 100%;
}

/* Modal Content */
.certificate-modal-content {
  padding: 8px 0;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  font-family: "WorkSans-SemiBold", sans-serif;
}

/* Certificate Header */
.certificate-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-radius: 16px;
  margin-bottom: 32px;
  border: 1px solid #a7f3d0;
}

.certificate-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
  flex-shrink: 0;
}

.certificate-header-content {
  flex: 1;
}

.certificate-title {
  color: #065f46;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.certificate-subtitle {
  color: #047857;
  font-size: 16px;
  margin: 0;
  font-weight: 500;
}

/* Information Section */
.certificate-info-section {
  margin-bottom: 32px;
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  margin-bottom: 24px;
}

.info-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-title {
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.info-text {
  color: #374151;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

/* ITI Verification */
.iti-verification {
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #e5e7eb;
}

.verification-title {
  color: #1e293b;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.verification-title i {
  color: #0f65b0;
}

.iti-link {
  display: block;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.iti-link:hover {
  text-decoration: none;
  color: inherit;
  border-color: #0f65b0;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.1);
  transform: translateY(-1px);
}

.iti-link-content {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.iti-logo {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  margin-right: 16px;
}

.iti-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.iti-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 16px;
}

.iti-description {
  font-size: 13px;
  color: #64748b;
  line-height: 1.3;
}

.iti-url {
  font-size: 12px;
  color: #0f65b0;
  font-weight: 500;
}

.iti-arrow {
  color: #64748b;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.iti-link:hover .iti-arrow {
  transform: translateX(4px);
  color: #0f65b0;
}

/* Loading Overlay */
.loading-overlay {
  border-radius: 16px;
  min-height: 200px;
}

/* Certificates Section */
.certificates-section {
  margin-bottom: 32px;
}

.section-header {
  margin-bottom: 24px;
}

.section-title {
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.section-title i {
  color: #0f65b0;
}

.certificates-count {
  background: #e0f2fe;
  color: #0c4a6e;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
}

/* No Certificates State */
.no-certificates {
  text-align: center;
  padding: 48px 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.no-certificates-icon {
  font-size: 48px;
  color: #cbd5e1;
  margin-bottom: 16px;
}

.no-certificates-title {
  color: #1e293b;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.no-certificates-text {
  color: #64748b;
  font-size: 14px;
  margin: 0;
}

/* Certificates Grid */
.certificates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
}

/* Certificate Card */
.certificate-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.certificate-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #cbd5e1;
}

/* Card Header */
.card-header-cert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e5e7eb;
}

.card-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
}

.card-badge {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 1px solid #34d399;
}

/* Card Content */
.card-content-cert {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cert-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cert-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cert-label i {
  color: #94a3b8;
}

.cert-value {
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.3;
}

.cert-time {
  font-size: 12px;
  color: #64748b;
  font-weight: 400;
}

/* Card Actions */
.card-actions-cert {
  padding: 0 24px 24px 24px;
}

.btn-download-cert {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-download-cert:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Certificate Footer */
.certificate-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.security-info,
.validation-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.security-info i {
  color: #10b981;
}

.validation-info i {
  color: #3b82f6;
}

/* Modal Override */
.modern-certificate-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-certificate-modal >>> .modal-body {
  padding: 32px !important;
}

.modern-certificate-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .certificates-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .certificate-header {
    flex-direction: column;
    text-align: center;
    gap: 16px;
    padding: 20px;
  }

  .certificate-title {
    font-size: 20px;
  }

  .certificate-subtitle {
    font-size: 14px;
  }

  .info-card {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }

  .info-icon {
    align-self: center;
  }

  .iti-verification {
    padding: 20px;
  }

  .iti-link-content {
    padding: 12px;
  }

  .iti-logo {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }

  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .certificate-footer {
    padding: 20px;
  }

  .modern-certificate-modal >>> .modal-body {
    padding: 24px !important;
  }
}

@media (max-width: 480px) {
  .certificate-header {
    padding: 16px;
  }

  .certificate-icon {
    width: 56px;
    height: 56px;
    font-size: 20px;
  }

  .certificate-title {
    font-size: 18px;
  }

  .certificate-subtitle {
    font-size: 13px;
  }

  .info-card {
    padding: 16px;
  }

  .info-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .iti-verification {
    padding: 16px;
  }

  .card-header-cert,
  .card-content-cert,
  .card-actions-cert {
    padding: 16px;
  }

  .card-actions-cert {
    padding-top: 0;
  }

  .certificate-footer {
    padding: 16px;
    gap: 8px;
  }

  .security-info,
  .validation-info {
    font-size: 13px;
  }

  .btn-certificate-small {
    padding: 6px 12px !important;
    font-size: 11px !important;
  }

  .modern-certificate-modal >>> .modal-body {
    padding: 16px !important;
  }
}

/* Animation for modal entrance */
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-certificate-modal >>> .modal-content {
  animation: modalSlideIn 0.3s ease-out;
}

/* Animation for certificate cards */
@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.certificate-card {
  animation: cardFadeIn 0.4s ease-out;
}

.certificate-card:nth-child(1) {
  animation-delay: 0.1s;
}
.certificate-card:nth-child(2) {
  animation-delay: 0.2s;
}
.certificate-card:nth-child(3) {
  animation-delay: 0.3s;
}
.certificate-card:nth-child(4) {
  animation-delay: 0.4s;
}
</style>